<template>
<div v-if="!dots"
     data-collapsable
     class="odr-spinner"
     :class="['odr-spinner_size_' + size]"
     :style="height && `height: ${height} !important;`">
    <div class="odr-spinner__text">
        <div class="odr-spinner__rotating">
            <div class="odr-spinner__path"/>
            <div class="odr-spinner__path odr-spinner__path_second"/>
        </div>
        <span v-if="!simple" class="odr-spinner__message">{{ message || $trl('aw.processing') }}</span>
    </div>
</div>
<span v-else>
    <svg class="odr-svg"
         xmlns:svg="http://www.w3.org/2000/svg"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         version="1.0"
         width="24px"
         height="6px"
         viewBox="0 0 128 32"
         xml:space="preserve">
        <circle fill="#757575"
                fill-opacity="1"
                cx="0"
                cy="0"
                r="11"
                transform="translate(16 16)">
            <animateTransform attributeName="transform"
                              type="scale"
                              additive="sum"
                              values="1;1.42;1;1;1;1;1;1;1;1"
                              dur="900ms"
                              repeatCount="indefinite"/>
        </circle>
        <circle fill="#757575"
                fill-opacity="1"
                cx="0"
                cy="0"
                r="11"
                transform="translate(64 16)">
            <animateTransform attributeName="transform"
                              type="scale"
                              additive="sum"
                              values="1;1;1;1;1.42;1;1;1;1;1"
                              dur="900ms"
                              repeatCount="indefinite"/>
        </circle>
        <circle fill="#757575"
                fill-opacity="1"
                cx="0"
                cy="0"
                r="11"
                transform="translate(112 16)">
            <animateTransform attributeName="transform"
                              type="scale"
                              additive="sum"
                              values="1;1;1;1;1;1;1;1.42;1;1"
                              dur="900ms"
                              repeatCount="indefinite"/>
        </circle>
    </svg>
</span>
</template>
<script>
import '@/scss/blocks/spinner.scss';

export default {
    props: {
        size: {
            type: String,
            default: 'normal',
        },
        simple: {
            type: Boolean,
            default: false,
        },
        height: {
            type: String,
        },
        dots: {
            type: Boolean,
            default: false,
        },
        message: {},
    },
};
</script>
